import type {
  SimpleChartData,
  SimpleChartDataset
} from '@blockanalitica/ui/package/types/src/components/charts/SimpleChart';
import { CurrencyValue, BarChart } from '@blockanalitica/ui';
import { useCallback, useMemo } from 'react';
import { useTheme } from 'styled-components';

export default function HistoricGraphs({
  data,
  type,
  chartDaysAgo
}: {
  type: string;
  chartDaysAgo: string;
  data: SimpleChartData[];
}) {
  const theme = useTheme();
  const datasets = useMemo(() => {
    let datasets: SimpleChartDataset[];

    if (type === 'supply_withdraw') {
      datasets = [
        {
          xField: 'date',
          yField: 'supply',
          label: 'Supply',
          backgroundColor: theme.colors.chartUp
        },
        {
          xField: 'date',
          yField: 'withdraw',
          label: 'Withdraw',
          backgroundColor: theme.colors.chartDown
        }
      ];
    } else {
      datasets = [
        {
          xField: 'date',
          yField: 'borrow',
          label: 'Borrow',
          backgroundColor: theme.colors.chartUp
        },
        {
          xField: 'date',
          yField: 'repay',
          label: 'Repay',
          backgroundColor: theme.colors.chartDown
        }
      ];
    }

    return datasets;
  }, [type, theme.colors]);

  const valueFormatter = useCallback(
    (value: string | number) => (
      <CurrencyValue value={value} options={{ currency: 'USD' }} />
    ),
    []
  );

  return (
    <BarChart
      key={type}
      data={data}
      datasets={datasets}
      valueFormatter={valueFormatter}
      daysAgo={chartDaysAgo}
    />
  );
}
